import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { accountingConnector } from "../../../../services/accounting/connector";

const ItemTemplate = ({
  item,
  itemColor,
  toggleMatchedInvestorDepositSendingFlag,
  investorDepositDepotIdOverride,
}) => {
  return (
    <div className="row" key={item.InvestorDepositId}>
      <div className="col-md-6">
        <ListItem disabled={true}>
          <ListItemAvatar>
            <Avatar
              backgroundColor={itemColor}
              style={{ backgroundColor: itemColor }}
            />
          </ListItemAvatar>
          PaymentId: {item.UniqueRef} <br />
          OCR: {item.DepositOcr} <br />
          Amount: {item.Amount} {item.Currency} <br />
          Year/Avi: {item.UniqueRef} <br />
          Depot Id: {item.DepotId} <br />
          Investor: {item.InvestorName} <br />
        </ListItem>
        <ListItem>
          {item.AmlWarning ? (
            <h4 style={{ color: "red" }}>
              Aml warning: {item.AmlWarning.toString()} <br />
            </h4>
          ) : undefined}
          {item.AmlWarning === null ? (
            <h4 style={{ color: "orange" }}>
              Wait few minutes for AML check. <br />
            </h4>
          ) : undefined}
        </ListItem>
        <ListItem>
          Depot Id Override: <br />
          <TextField
            onBlur={(e) =>
              investorDepositDepotIdOverride(
                item.InvestorDepositId,
                e.target.value,
              )
            }
            defaultValue={item.DepotId}
          />
          <br />
        </ListItem>
      </div>
      <div className="col-md-6">
        {!!item.DepotId && (
          <Button
            variant="contained"
            color="primary"
            onClick={toggleMatchedInvestorDepositSendingFlag.bind(this, item)}
          >
            Toggle investor deposit sending
          </Button>
        )}
        {!item.DepotId && (
          <span style={{ color: "red" }}>Missing Depot Id</span>
        )}
      </div>
    </div>
  );
};

export default accountingConnector(ItemTemplate);
